import { ButtonGroup, HStack, Icon, VStack, Text, DataList, DataItem } from '@cad-arc';
import { PanelTitle } from '../../../panels/panel-title';
import { EntityStatusIcon } from '../../../entity-status-icon';
import { EntityPanelHeaderResizeButtons } from '../../../panels/entity-panels/entity-panel-header-resize-buttons';
import { useBootstrapState } from '../../../bootstrap/bootstrap-provider';
import { useBoloPanelMetadata } from '../state/bolo-panel-metadata-context';
import { observer } from 'mobx-react-lite';
import { BoloPanelKebabMenu } from './bolo-panel-kebab-menu';

export const BoloPanelHeader = observer(() => {
    const { userProfileView } = useBootstrapState();
    const creator = `${userProfileView.firstName.substring(0)} ${userProfileView.lastName}`;

    const metadata = useBoloPanelMetadata();
    const boloExists = !!metadata?.boloId;
    const isExpired = !!metadata?.actualExpirationDateUtc;

    return (
        <HStack align="start" w="full" pb={1} spacing={0}>
            <VStack align="start" spacing={0} pl={2} w="full">
                <HStack justify="space-between" w="full">
                    <HStack minWidth={0}>
                        <PanelTitle>
                            <HStack spacing="1" alignItems="flex-start">
                                {boloExists ? (
                                    <>
                                        <Icon size="sm" icon="Visibility" />
                                        <span>
                                            <Text as="span">{metadata.title}</Text>
                                        </span>
                                    </>
                                ) : (
                                    <VStack alignItems="flex-start">
                                        <span>New BOLO</span>
                                    </VStack>
                                )}
                            </HStack>
                        </PanelTitle>
                    </HStack>
                    <ButtonGroup size="sm" style={{ alignItems: 'center' }}>
                        {boloExists ? <EntityStatusIcon isActive={!isExpired} /> : undefined}
                        <BoloPanelKebabMenu boloId={metadata?.boloId} />
                        <EntityPanelHeaderResizeButtons
                            isXXLEnabled={!!boloExists}
                            panelType="BOLO"
                        />
                    </ButtonGroup>
                </HStack>
                <DataList direction="row" variant="inline">
                    <DataItem dataKey="Creator">{creator}</DataItem>
                </DataList>
            </VStack>
        </HStack>
    );
});
